/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

import{$getEditor as e}from"lexical";import{getExtensionDependencyFromEditor as n}from"@lexical/extension/getExtensionDependencyFromEditor";import{getPeerDependencyFromEditor as t}from"@lexical/extension/getPeerDependencyFromEditor";function o(t){return n(e(),t)}function r(e){return o(e).output}function i(n){return t(e(),n)}export{o as $getExtensionDependency,r as $getExtensionOutput,i as $getPeerDependency};
